import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

import { SUSPENSION_MESSAGE } from "../config";

// Watermarks the booking area while reservations are suspended. The page
// stays readable underneath so guests can still see what they booked.
const SuspendedOverlay = ({ children }) => (
  <>
    <Paper
      elevation={3}
      sx={{
        mt: 1,
        px: 3,
        py: 2,
        textAlign: "center",
        borderTop: "4px solid",
        borderColor: "secondary.main",
      }}
    >
      <LockIcon color="secondary" />
      <Typography variant="h6" sx={{ mt: 0.5 }}>
        Reservations are closed
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {SUSPENSION_MESSAGE}
      </Typography>
    </Paper>

    <Box sx={{ position: "relative", mt: 1 }}>
      <Box sx={{ opacity: 0.4, pointerEvents: "none", userSelect: "none" }}>
        {children}
      </Box>

      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <Typography
          sx={{
            transform: "rotate(-24deg)",
            fontSize: { xs: "2.2rem", sm: "3.4rem" },
            fontWeight: 900,
            letterSpacing: 6,
            color: "rgba(0, 74, 88, 0.16)",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
          }}
        >
          Booking Closed
        </Typography>
      </Box>
    </Box>
  </>
);

export default SuspendedOverlay;
